import { IndeterminateProgressCircle } from '@sunwebgroup/uds-ui/IndeterminateProgressCircle'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import styles from './styles.module.css'

export function Loader({ text }: { text?: string }) {
  return (
    <div className={styles.loaderContainer} role={text ? 'status' : undefined}>
      <IndeterminateProgressCircle className={styles.loader} size={32} />
      {text && <Typography variant="body-s-regular-tight" className={styles.loaderText}>{text}</Typography>}
    </div>
  )
}
